import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import Hero from '../components/Hero'
import SectionHeading from '../components/SectionHeading'
import ServiceCard from '../components/ServiceCard'
import ProcessTimeline from '../components/ProcessTimeline'
import TestimonialSlider from '../components/TestimonialSlider'
import CTASection from '../components/CTASection'
import ScrollReveal from '../components/ScrollReveal'
import SocialIcons from '../components/SocialIcons'
import { services, galleryItems, socials } from '../data/siteData'
import { bgPhoto } from '../utils/img'
import './Home.css'

export default function Home() {
  const previewServices = services.slice(0, 3)
  const previewGallery = galleryItems.slice(0, 6)

  return (
    <>
      <SEO
        title="AS Elite Gatherings | Wedding & Event Management in Marthandam, Tamil Nadu"
        description="Weddings, corporate events, product launches, private parties and stage decoration — planned and produced in Marthandam, Tamil Nadu. Call +91 63822 82058."
        keywords="event management Marthandam, wedding planners Marthandam, corporate event management Tamil Nadu, stage decoration Marthandam, wedding decorators Kanniyakumari, event planners Tamil Nadu, party planners Marthandam"
        path="/"
      />
      <Hero />

      <section className="section">
        <div className="container about-teaser">
          <ScrollReveal direction="left" className="about-teaser-media">
            <img src={bgPhoto('/images/bg/bg1.webp')} alt="AS Elite Gatherings event setup" />
            <div className="about-teaser-badge">
              <span>Marthandam's</span>
              <strong>Event Studio</strong>
            </div>
          </ScrollReveal>
          <ScrollReveal direction="right" delay={100} className="about-teaser-copy">
            <span className="eyebrow">Who We Are</span>
            <h2 className="gold-underline animate">
              We plan the room so you can be a guest at your own event
            </h2>
            <p>
              AS Elite Gatherings is an event management studio based in Marthandam,
              Tamil Nadu. We produce <Link to="/services#corporate-events">corporate events</Link>,{' '}
              <Link to="/services#product-launch">product launches</Link>,{' '}
              <Link to="/services#private-party">private parties</Link>,{' '}
              <Link to="/services#wedding">weddings</Link>,{' '}
              <Link to="/services#stage-decoration">stage decoration</Link>, and{' '}
              <Link to="/services#cultural-award-shows">award & cultural shows</Link> — with
              the same care whether the room holds fifty guests or five hundred.
            </p>
            <p>
              Our work spans staging, décor, lighting and full-day coordination, built
              around one idea: every gathering deserves to feel deliberate. Take a look at
              our <Link to="/gallery">event gallery</Link> or{' '}
              <Link to="/videos">watch our highlight videos</Link> to see it in action.
            </p>
            <Link to="/about" className="btn btn-ghost">Our Story</Link>
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <SectionHeading
            eyebrow="What We Do"
            title="Event experiences, designed end to end"
            text="Six ways we bring a gathering to life — each handled by the same studio, the same eye for detail."
          />
          <div className="home-services-grid">
            {previewServices.map((s, i) => (
              <ServiceCard service={s} key={s.id} delay={i * 100} />
            ))}
          </div>
          <ScrollReveal className="home-services-more">
            <Link to="/services" className="btn btn-primary">View All Services</Link>
          </ScrollReveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="Our Work" title="Moments we've helped create" center />
          <div className="home-gallery-grid">
            {previewGallery.map((item, i) => (
              <ScrollReveal as="figure" key={item.id} delay={(i % 6) * 60} className="home-gallery-item">
                <img
                  src={bgPhoto(item.image)}
                  alt={item.title}
                  loading="lazy"
                  width={1920}
                  height={1080}
                />
                <figcaption>{item.title}</figcaption>
              </ScrollReveal>
            ))}
          </div>
          <ScrollReveal className="home-services-more">
            <Link to="/gallery" className="btn btn-ghost">See Full Gallery</Link>
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <SectionHeading
            eyebrow="How It Works"
            title="A process built for calm event days"
            center
          />
          <ProcessTimeline />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHeading eyebrow="Kind Words" title="What our clients say" center />
          <TestimonialSlider />
        </div>
      </section>


      <section className="section section-alt">
        <div className="container follow-strip">
          <ScrollReveal>
            <span className="eyebrow">Follow Along</span>
            <h2 className="gold-underline animate">See it happen in real time</h2>
            <p>Behind-the-scenes setups, reveal moments and highlight reels, straight from our socials — or browse the full <Link to="/gallery">photo gallery</Link>.</p>
            <SocialIcons variant="inline" />
          </ScrollReveal>
          <ScrollReveal delay={120} className="follow-strip-links">
            <a href={socials.instagram} target="_blank" rel="noreferrer" className="follow-card">
              <strong>Instagram</strong>
              <span>@aselite_gatherings</span>
            </a>
            <a href={socials.facebook} target="_blank" rel="noreferrer" className="follow-card">
              <strong>Facebook</strong>
              <span>AS Elite Gatherings</span>
            </a>
            <a href={socials.youtube} target="_blank" rel="noreferrer" className="follow-card">
              <strong>YouTube</strong>
              <span>@aselitegathering</span>
            </a>
          </ScrollReveal>
        </div>
      </section>

      <CTASection />
    </>
  )
}
